export default __webpack_public_path__ + "static/media/exam.3eecbeac.svg";